<template>
	<div class="link-dropdown">
		<div class="link-dropdown-reference"
			 ref="reference"
			 v-on="referenceListening">
			<template v-if="type === 'button'">
				<link-button iconPosition="right" :icon="p_value?'link-icon-up':'link-icon-down'" v-bind="buttonProps">
					<slot name="reference"></slot>
				</link-button>
			</template>
			<slot name="reference" v-else></slot>
		</div>
		<link-popover
			ref="popover"
			v-bind="popoverBinding"
			@show="onChange(true)"
			@close="onChange(false)">
			<div class="link-dropdown-content">
				<slot name="popover"></slot>
			</div>
		</link-popover>
	</div>
</template>

<script>

	import {MountedMixin} from "../mixins";

	export default {
		name: "link-dropdown",
		mixins: [MountedMixin],
		props: {
			value: {type: Boolean, default: false},

			trigger: {type: String, default: 'click',},
			hideOnClickItem: {type: Boolean, default: true},
			disabled: {type: Boolean, default: false},
			showArrow: {type: Boolean, default: true},
			sizeEqual: {type: Boolean, default: false, desc: '是否令popper与reference在方向上宽度一致'},
			offset: {type: Number, default: 12, desc: 'popper与reference的距离'},
			hideOnClickOutside: {type: Boolean, default: true, desc: '是否在点击popover外部元素的时候，关闭popover'},
			height: {type: Number, default: 144},
			width: {type: Number | String, default: '100px'},

			direction: {type: String, default: 'bottom', desc: '位置，有四种选择：上下左右',},
			align: {type: String, default: 'start', desc: '对其方式，如果direction是上或者下，那对其方式start、center、end对应为左对齐，居中对其以及右对齐，反之为顶部对其、居中对其以及底部对其',},
			type: {type: String, default: null},
			buttonProps: {type: Object},
		},
		data() {
			return {
				p_value: this.value,

			}
		},
		computed: {
			popoverBinding() {
				return {
					reference: !!this.lv_mounted ? this.$refs.reference : null,
					popper: {
						arrow: this.showArrow,
						disabledEqual: !this.sizeEqual,
						height: this.height,
						width: this.width,
						direction: this.direction,
						align: this.align,
						offset: this.offset,
					}
				}
			},
			referenceListening() {
				const that = this
				if (this.trigger === 'click') {
					return {
						'click': () => {
							!!that.p_value ? that.hide() : that.show()
						}
					}
				}
			},
		},
		watch: {
			value(val) {
				if (val !== this.p_value) {
					!!val ? this.show() : this.hide()
				}
			},
		},
		methods: {
			show() {
				this.$refs.popover.show()
			},
			hide() {
				this.$refs.popover.hide()
			},

			onChange(val) {
				this.p_value = val
				this.value !== val && this.$emit('input', val)
			},

		},
	}
</script>

<style lang="scss">
	@include themeify {
		.link-dropdown {
			display: inline-block;
			vertical-align: bottom;
			box-sizing: border-box;
		}
		.link-dropdown-content {
			width: 100%;
			box-sizing: border-box;
			padding: 3px;

			.link-dropdown-item {
				min-height: 24px;
				margin-bottom: 3px;
				padding: 4px 9px;
				font-size: 12px;
				cursor: pointer;
				box-sizing: border-box;
				width: 100%;
				outline: none;

				&:hover {
					background-color: pl-var(color-primary-light);
				}
			}
		}
	}
</style>
